import {
  Seat,
  ChartData,
  PickUpData,
  DropOffData,
} from "src/containers/chart/types";

export enum Types {
  SET_CHART_DATA = "SET_CHART_DATA",
  SET_SELECTED_SEATS = "SET_SELECTED_SEATS",
  SET_LOADING = "SET_LOADING",
  SET_FARE_BREAKUP = "SET_FARE_BREAKUP",
  SET_SELECTED_PICKUP = "SET_SELECTED_PICKUP",
  SET_SELECTED_DROPOFF = "SET_SELECTED_DROPOFF",
  CLEAR_CHART_CONTEXT = "CLEAR_CHART_CONTEXT",
  SET_SHOW_SEAT_LAYOUT = "SET_SHOW_SEAT_LAYOUT",
}

export interface ChartFareBreakup {
  seats: number;
  fare: { [key: string]: number };
  fareCategory: { [key: string]: string };
  fareLabel: { [key: string]: string };
}

export type Action =
  | { type: Types.SET_CHART_DATA; payload: ChartData }
  | { type: Types.SET_SELECTED_SEATS; payload: Seat[] }
  | { type: Types.SET_LOADING; payload: string }
  | { type: Types.SET_FARE_BREAKUP; payload: ChartFareBreakup }
  | { type: Types.SET_SELECTED_PICKUP; payload: PickUpData }
  | { type: Types.SET_SELECTED_DROPOFF; payload: DropOffData }
  | { type: Types.CLEAR_CHART_CONTEXT; payload: null }
  | { type: Types.SET_SHOW_SEAT_LAYOUT; payload: boolean };

export interface ChartStore {
  showSeatLayout: boolean;
  loading: string;
  chartData: ChartData | null;
  errMsg: boolean;
  selectedSeats: Seat[] | [];
  fareBreakup: ChartFareBreakup;
  selectedPickup: PickUpData | null;
  selectedDropoff: DropOffData | null;
}
